import axios from "axios";
import { getRequester, getToken } from "../utils/commons";
import { message } from "antd";
import CryptoJS from "crypto-js";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

/* =========================
   AXIOS INTERCEPTOR
========================= */
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      message.error("Session expired. Logging out now...");
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    }
    return Promise.reject(error);
  }
);

/* =========================
   HEADERS BUILDER
========================= */
const buildHeaders = (isFormData) => ({
  "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  "API-KEY": API_KEY,
});

/* =========================
   ERROR HANDLER (IMPORTANT FIX)
========================= */
const handleError = (error) => {
  console.error("API ERROR:", error?.response || error);

  const messageText =
    error?.response?.data?.message || error?.message || "Something went wrong";

  message.error(messageText);

  throw error; // 🔥 IMPORTANT: stop fake success
};

/* =========================
   GET REQUEST
========================= */
export const getRequest = async (apiName, params = {}) => {
  const url = `${BASE_URL}/${apiName}`;

  const payload = {
    ...params,
    token: getToken(),
    requester: getRequester(),
  };

  try {
    const response = await axios.get(url, {
      params: payload,
      headers: buildHeaders(false),
    });

    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

/* =========================
   POST REQUEST
========================= */
export const postRequest = async (apiName, data = {}, isFormData = false) => {
  const url = `${BASE_URL}/${apiName}`;

  let payload;

  if (isFormData) {
    payload = data;
    payload.append("token", getToken());
    payload.append("requester", getRequester());
  } else {
    payload = {
      ...data,
      token: getToken(),
      requester: getRequester(),
    };
  }

  try {
    const response = await axios.post(url, payload, {
      headers: buildHeaders(isFormData),
    });

    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

/* =========================
   PUT REQUEST (FIXED - IMPORTANT)
========================= */
export const putRequest = async (apiName, data = {}, isFormData = false) => {
  const url = `${BASE_URL}/${apiName}`;

  let payload;

  if (isFormData) {
    payload = data;
    payload.append("token", getToken());
    payload.append("requester", getRequester());
  } else {
    payload = {
      ...data,
      token: getToken(),
      requester: getRequester(),
    };
  }

  try {
    const response = await axios.put(url, payload, {
      headers: buildHeaders(isFormData),
    });

    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

/* =========================
   FILE UPLOAD
========================= */
export const uploadFile = async (file) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("token", getToken());
  formData.append("requester", getRequester());

  try {
    const response = await axios.post(`${BASE_URL}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "API-KEY": API_KEY,
      },
    });

    return response.data;
  } catch (error) {
    return handleError(error);
  }
};
